import * as BaseToggleTokens from './tokens';
export const CFBaseToggleTokens = BaseToggleTokens;
